(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yvx-size-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    const selectedFilters = new Set();
    const initialFilters = (new URL(window.location.href).searchParams.get('yvx_size') || '').split(',').filter(Boolean);

    initialFilters.forEach(filter => {
      if (filter.includes(':')) {
        selectedFilters.add(filter);
      } else if (/^\d+$/.test(filter)) {
        selectedFilters.add(`BOTTOMS:${filter}`);
      } else {
        selectedFilters.add(`TOPS:${filter}`);
      }
    });

    function findRefineMenu() {
      const desktop = document.querySelector('#Details-HeaderMenu-1 > .header__submenu');
      const mobile = document.querySelector('#link-REFINE .menu-drawer__menu');
      return window.matchMedia('(min-width: 990px)').matches ? desktop : mobile;
    }

    function placeInRefine(filter) {
      const menu = findRefineMenu();
      if (!menu) return;

      let slot = menu.querySelector('[data-yvx-size-filter-slot]');
      if (!slot) {
        slot = document.createElement('li');
        slot.className = 'yvx-size-filter-menu__slot';
        slot.dataset.yvxSizeFilterSlot = 'true';
        menu.appendChild(slot);
      }

      if (filter.parentElement !== slot) slot.appendChild(filter);
    }

    function updateUrl() {
      const url = new URL(window.location.href);
      if (selectedFilters.size) {
        url.searchParams.set('yvx_size', Array.from(selectedFilters).join(','));
      } else {
        url.searchParams.delete('yvx_size');
      }
      url.searchParams.delete('page');
      window.history.replaceState({}, '', url);
    }

    function updateCounts() {
      const counts = new Map();
      document.querySelectorAll('[data-yvx-size-count]').forEach(node => {
        counts.set(`${node.dataset.yvxSizeGroup}:${node.dataset.yvxSizeCount}`, 0);
      });

      document.querySelectorAll('#product-grid > .grid__item').forEach(item => {
        const group = item.dataset.yvxProductGroup || '';
        const sizes = new Set(String(item.dataset.yvxAvailableSizes || '').split(/\s+/).filter(Boolean));
        sizes.forEach(size => {
          const key = `${group}:${size}`;
          if (counts.has(key)) counts.set(key, counts.get(key) + 1);
        });
      });

      document.querySelectorAll('[data-yvx-size-count]').forEach(node => {
        const key = `${node.dataset.yvxSizeGroup}:${node.dataset.yvxSizeCount}`;
        const count = counts.get(key) || 0;
        node.textContent = count;
        const option = node.closest('.yvx-size-filter__option');
        option.classList.toggle('yvx-size-filter__option--empty', count === 0);
      });
    }

    function applyFilter() {
      const items = Array.from(document.querySelectorAll('#product-grid > .grid__item'));
      let visibleCount = 0;

      items.forEach(item => {
        const group = item.dataset.yvxProductGroup || '';
        const sizes = String(item.dataset.yvxAvailableSizes || '').split(/\s+/).filter(Boolean);
        const visible = selectedFilters.size === 0 || Array.from(selectedFilters).some(filter => {
          const separator = filter.indexOf(':');
          const filterGroup = filter.slice(0, separator);
          const filterSize = filter.slice(separator + 1);
          return group === filterGroup && sizes.includes(filterSize);
        });
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      document.querySelectorAll('[data-yvx-size-option]').forEach(input => {
        input.checked = selectedFilters.has(`${input.dataset.yvxSizeGroup}:${input.value}`);
      });

      document.querySelectorAll('[data-yvx-size-clear]').forEach(button => {
        button.hidden = selectedFilters.size === 0;
      });

      document.querySelectorAll('[data-yvx-size-status]').forEach(status => {
        status.textContent = selectedFilters.size ? `${visibleCount} IN-STOCK ITEMS` : '';
      });
    }

    function init(filter) {
      if (!filter || filter.dataset.initialized === 'true') return;
      filter.dataset.initialized = 'true';
      placeInRefine(filter);

      filter.querySelectorAll('[data-yvx-size-option]').forEach(input => {
        input.addEventListener('change', () => {
          const key = `${input.dataset.yvxSizeGroup}:${input.value}`;
          if (input.checked) {
            selectedFilters.add(key);
          } else {
            selectedFilters.delete(key);
          }
          updateUrl();
          applyFilter();
        });
      });

      filter.querySelector('[data-yvx-size-clear]').addEventListener('click', () => {
        selectedFilters.clear();
        updateUrl();
        applyFilter();
      });

      updateCounts();
      applyFilter();
    }

    function initAll() {
      document.querySelectorAll('[data-yvx-size-filter]').forEach(init);
    }

    initAll();
    window.matchMedia('(min-width: 990px)').addEventListener('change', () => {
      document.querySelectorAll('[data-yvx-size-filter]').forEach(placeInRefine);
    });
    document.addEventListener('shopify:section:load', initAll);

    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      new MutationObserver(() => {
        updateCounts();
        applyFilter();
      }).observe(gridContainer, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yvx-snake-entrance-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  const API = 'https://rbjtymffrzyttmmodfxe.supabase.co/functions/v1/yvx-snake-leaderboard';
  const GRID = 40;
  const LETTERS = ['Y', 'V', 'X'];
  const START_SPEED = 270;
  const MIN_SPEED = 80;
  const SPEED_STEP = 5;
  const SPRITE_TILE = 64;
  const SPRITES = {
    headRight: [0, 0],
    headDown: [1, 0],
    headLeft: [2, 0],
    headUp: [3, 0],
    bodyHorizontal: [0, 1],
    bodyVertical: [1, 1],
    cornerUpRight: [2, 1],
    cornerRightDown: [3, 1],
    cornerDownLeft: [0, 2],
    cornerLeftUp: [1, 2],
    tailRight: [2, 2],
    tailDown: [3, 2],
    tailLeft: [0, 3],
    tailUp: [1, 3]
  };

  function init(root) {
    if (!root) return;

    const forceSnake = new URLSearchParams(window.location.search).get('yvxsnake') === '1';
    let hasEntered = false;
    try { hasEntered = sessionStorage.getItem('yvx_snake_entered_v1') === '1'; } catch (error) {}

    if (hasEntered && !forceSnake) {
      root.remove();
      return;
    }

    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    try { sessionStorage.setItem('yvx_intro_entered_v1', '1'); } catch (error) {}
    document.documentElement.classList.remove('yvx-intro-pending');
    document.documentElement.classList.add('yvx-intro-seen');

    const legacyIntro = document.getElementById('yvx-intro');
    const legacyVideo = document.getElementById('yvx-intro-video');
    if (legacyVideo) legacyVideo.pause();
    if (legacyIntro) legacyIntro.remove();

    const canvas = root.querySelector('[data-board]');
    const ctx = canvas.getContext('2d');
    const leaderboardEl = root.querySelector('[data-leaderboard]');
    const scoreEl = root.querySelector('[data-score]');
    const letterEl = root.querySelector('[data-letter]');
    const startScreen = root.querySelector('[data-start-screen]');
    const startError = root.querySelector('[data-start-error]');
    const gameOverScreen = root.querySelector('[data-game-over-screen]');
    const claim = root.querySelector('[data-claim]');
    const nameInput = root.querySelector('[data-name]');
    const nameError = root.querySelector('[data-name-error]');
    const playButton = root.querySelector('[data-play]');
    const skipButton = root.querySelector('[data-skip]');
    const saveScoreButton = root.querySelector('[data-save-score]');
    const playAgainButton = root.querySelector('[data-play-again]');
    const enterButton = root.querySelector('[data-enter]');
    const finalScoreEl = root.querySelector('[data-final-score]');
    const saveStatusEl = root.querySelector('[data-save-status]');
    const dirButtons = root.querySelectorAll('[data-dir]');
    const size = canvas.width / GRID;
    const oldOverflow = document.documentElement.style.overflow;
    const spriteImage = new Image();
    const spriteUrl = root.dataset.snakeSpriteUrl || '';
    let spriteLoaded = false;

    let snake = [];
    let direction = { x: 1, y: 0 };
    let nextDirection = { x: 1, y: 0 };
    let food = { x: 28, y: 20 };
    let letterIndex = 0;
    let score = 0;
    let timer = null;
    let running = false;
    let touchStart = null;
    let sessionId = '';
    let gameStartedAt = 0;
    let scoreSubmitted = false;
    let latestScores = [];

    const spriteReady = new Promise(resolve => {
      if (!spriteUrl) {
        resolve(false);
        return;
      }

      spriteImage.decoding = 'async';
      spriteImage.addEventListener('load', () => {
        spriteLoaded = true;
        draw();
        resolve(true);
      }, { once: true });
      spriteImage.addEventListener('error', () => resolve(false), { once: true });
      spriteImage.src = spriteUrl;
      if (spriteImage.complete && spriteImage.naturalWidth) {
        spriteLoaded = true;
        resolve(true);
      }
    });

    document.documentElement.style.overflow = 'hidden';

    function cleanName(value) {
      return String(value || '')
        .trim()
        .replace(/\s+/g, ' ')
        .replace(/[^a-zA-Z0-9 _.-]/g, '')
        .slice(0, 12)
        .toUpperCase();
    }

    function deviceType() {
      return window.matchMedia('(pointer:coarse)').matches || window.innerWidth < 750 ? 'mobile' : 'desktop';
    }

    async function api(action, options = {}) {
      const response = await fetch(`${API}?action=${encodeURIComponent(action)}`, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...(options.headers || {})
        }
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || 'Request failed');
      return data;
    }

    function normalizeScores(scores) {
      if (!Array.isArray(scores)) return [];
      return scores
        .filter(entry => entry && Number.isFinite(Number(entry.score)))
        .map(entry => ({
          player_name: cleanName(entry.player_name) || 'GUEST',
          score: Math.max(0, Math.floor(Number(entry.score))),
          duration_ms: Math.max(0, Math.floor(Number(entry.duration_ms) || 0))
        }))
        .sort((a, b) => b.score - a.score || a.duration_ms - b.duration_ms);
    }

    function renderScores(scores = []) {
      latestScores = normalizeScores(scores);
      leaderboardEl.replaceChildren();
      const top = latestScores.slice(0, 3);

      for (let index = 0; index < 3; index += 1) {
        const entry = top[index];
        const item = document.createElement('li');
        item.className = 'yvx-snake-entrance__leaderboard-item';

        const rank = document.createElement('span');
        rank.className = 'yvx-snake-entrance__leaderboard-rank';
        rank.textContent = `${index + 1}.`;

        const name = document.createElement('span');
        name.className = 'yvx-snake-entrance__leaderboard-name';
        name.textContent = entry ? entry.player_name : '-';

        const points = document.createElement('span');
        points.className = 'yvx-snake-entrance__leaderboard-score';
        points.textContent = entry ? String(entry.score) : '0';

        item.append(rank, name, points);
        leaderboardEl.append(item);
      }
    }

    async function loadLeaderboard() {
      try {
        const data = await api('leaderboard');
        renderScores(data.scores);
        return latestScores;
      } catch (error) {
        if (!latestScores.length) renderScores([]);
        return latestScores;
      }
    }

    function qualifiesForTopThree(value, scores) {
      if (value <= 0) return false;
      const top = normalizeScores(scores).slice(0, 3);
      if (top.length < 3) return true;
      return value >= top[top.length - 1].score;
    }

    async function createSession() {
      const data = await api('start', {
        method: 'POST',
        body: JSON.stringify({ device_type: deviceType() })
      });
      sessionId = data.session_id || '';
      gameStartedAt = Date.now();
    }

    async function submitScore(playerName = 'GUEST') {
      if (scoreSubmitted || !sessionId) return true;

      const cleaned = cleanName(playerName) || 'GUEST';
      const durationMs = Math.max(500, Date.now() - gameStartedAt);
      saveStatusEl.textContent = 'SAVING SCORE...';

      try {
        const data = await api('submit', {
          method: 'POST',
          body: JSON.stringify({
            session_id: sessionId,
            player_name: cleaned,
            score,
            duration_ms: durationMs,
            device_type: deviceType()
          })
        });
        scoreSubmitted = true;
        saveStatusEl.textContent = cleaned === 'GUEST' ? 'SCORE TRACKED' : 'SCORE SAVED';
        renderScores(data.scores);
        return true;
      } catch (error) {
        saveStatusEl.textContent = 'SCORE COULD NOT SAVE';
        loadLeaderboard();
        return false;
      }
    }

    function spawnFood() {
      const free = [];
      for (let y = 0; y < GRID; y += 1) {
        for (let x = 0; x < GRID; x += 1) {
          if (!snake.some(part => part.x === x && part.y === y)) free.push({ x, y });
        }
      }
      if (!free.length) return false;
      food = free[Math.floor(Math.random() * free.length)];
      return true;
    }

    function getSpeed() {
      return Math.max(MIN_SPEED, START_SPEED - score * SPEED_STEP);
    }

    function updateHud() {
      scoreEl.textContent = String(score);
      letterEl.textContent = LETTERS[letterIndex];
    }

    function wrappedVector(from, to) {
      let x = to.x - from.x;
      let y = to.y - from.y;
      if (x > 1) x = -1;
      if (x < -1) x = 1;
      if (y > 1) y = -1;
      if (y < -1) y = 1;
      return { x: Math.sign(x), y: Math.sign(y) };
    }

    function vectorName(vector) {
      if (vector.x > 0) return 'Right';
      if (vector.x < 0) return 'Left';
      if (vector.y > 0) return 'Down';
      return 'Up';
    }

    function opposite(vector) {
      return { x: -vector.x, y: -vector.y };
    }

    function spriteForSegment(index) {
      const part = snake[index];
      if (!part) return 'bodyHorizontal';

      if (snake.length === 1) return `head${vectorName(direction)}`;

      if (index === 0) {
        const towardNeck = wrappedVector(part, snake[1]);
        return `head${vectorName(opposite(towardNeck))}`;
      }

      if (index === snake.length - 1) {
        const towardBody = wrappedVector(part, snake[index - 1]);
        return `tail${vectorName(opposite(towardBody))}`;
      }

      const towardHead = wrappedVector(part, snake[index - 1]);
      const towardTail = wrappedVector(part, snake[index + 1]);

      if (towardHead.x !== 0 && towardTail.x !== 0) return 'bodyHorizontal';
      if (towardHead.y !== 0 && towardTail.y !== 0) return 'bodyVertical';

      const connections = new Set([vectorName(towardHead), vectorName(towardTail)]);
      if (connections.has('Up') && connections.has('Right')) return 'cornerUpRight';
      if (connections.has('Right') && connections.has('Down')) return 'cornerRightDown';
      if (connections.has('Down') && connections.has('Left')) return 'cornerDownLeft';
      if (connections.has('Left') && connections.has('Up')) return 'cornerLeftUp';
      return towardHead.x !== 0 ? 'bodyHorizontal' : 'bodyVertical';
    }

    function drawSnakeSegment(part, index) {
      const key = spriteForSegment(index);
      const sprite = SPRITES[key];
      if (!spriteLoaded || !sprite) {
        const inset = index === 0 ? Math.max(1, Math.round(size * 0.08)) : Math.max(1, Math.round(size * 0.13));
        ctx.fillStyle = index === 0 ? '#45e376' : '#2fc861';
        ctx.fillRect(part.x * size + inset, part.y * size + inset, size - inset * 2, size - inset * 2);
        return;
      }

      const sourceX = sprite[0] * SPRITE_TILE;
      const sourceY = sprite[1] * SPRITE_TILE;
      ctx.drawImage(
        spriteImage,
        sourceX,
        sourceY,
        SPRITE_TILE,
        SPRITE_TILE,
        part.x * size,
        part.y * size,
        size,
        size
      );
    }

    function draw() {
      ctx.fillStyle = '#090909';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.strokeStyle = 'rgba(244,244,239,.04)';
      ctx.lineWidth = 1;
      for (let index = 1; index < GRID; index += 1) {
        const position = index * size;
        ctx.beginPath();
        ctx.moveTo(position, 0);
        ctx.lineTo(position, canvas.height);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, position);
        ctx.lineTo(canvas.width, position);
        ctx.stroke();
      }

      ctx.imageSmoothingEnabled = true;
      if ('imageSmoothingQuality' in ctx) ctx.imageSmoothingQuality = 'high';
      snake.forEach(drawSnakeSegment);

      ctx.fillStyle = '#f4f4ef';
      ctx.font = `900 ${Math.max(8, Math.floor(size * 0.82))}px Arial, Helvetica, sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(LETTERS[letterIndex], food.x * size + size / 2, food.y * size + size / 2 + 1);
    }

    function stop() {
      running = false;
      if (timer) window.clearTimeout(timer);
      timer = null;
    }

    function schedule() {
      if (!running) return;
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        timer = null;
        tick();
        if (running) schedule();
      }, getSpeed());
    }

    async function lose() {
      if (!running) return;
      stop();
      finalScoreEl.textContent = `SCORE ${score}`;
      gameOverScreen.hidden = false;
      claim.hidden = true;
      nameInput.value = '';
      nameError.hidden = true;
      saveStatusEl.textContent = 'CHECKING HIGH SCORES...';

      const scores = await loadLeaderboard();
      if (qualifiesForTopThree(score, scores)) {
        saveStatusEl.textContent = '';
        claim.hidden = false;
        window.setTimeout(() => nameInput.focus({ preventScroll: true }), 0);
      } else {
        await submitScore('GUEST');
        enterButton.focus({ preventScroll: true });
      }
    }

    function tick() {
      direction = nextDirection;
      const head = {
        x: (snake[0].x + direction.x + GRID) % GRID,
        y: (snake[0].y + direction.y + GRID) % GRID
      };

      const willEat = head.x === food.x && head.y === food.y;
      const collisionBody = willEat ? snake : snake.slice(0, -1);
      if (collisionBody.some(part => part.x === head.x && part.y === head.y)) {
        lose();
        return;
      }

      snake.unshift(head);
      if (willEat) {
        score += 1;
        letterIndex = (letterIndex + 1) % LETTERS.length;
        updateHud();
        if (!spawnFood()) {
          lose();
          return;
        }
      } else {
        snake.pop();
      }
      draw();
    }

    function setDirection(name) {
      const map = {
        up: { x: 0, y: -1 },
        down: { x: 0, y: 1 },
        left: { x: -1, y: 0 },
        right: { x: 1, y: 0 }
      };
      const candidate = map[name];
      if (!candidate || !running) return;
      if (candidate.x === -nextDirection.x && candidate.y === -nextDirection.y) return;
      nextDirection = candidate;
    }

    function prepareBoard() {
      stop();
      score = 0;
      letterIndex = 0;
      direction = { x: 1, y: 0 };
      nextDirection = { x: 1, y: 0 };
      snake = [
        { x: 14, y: 20 },
        { x: 13, y: 20 },
        { x: 12, y: 20 },
        { x: 11, y: 20 }
      ];
      spawnFood();
      updateHud();
      draw();
    }

    async function startGame() {
      startError.hidden = true;
      scoreSubmitted = false;
      sessionId = '';
      playButton.disabled = true;
      playButton.textContent = 'LOADING...';

      try {
        await Promise.all([createSession(), spriteReady]);
      } catch (error) {
        playButton.disabled = false;
        playButton.textContent = 'PLAY';
        startError.hidden = false;
        return;
      }

      playButton.disabled = false;
      playButton.textContent = 'PLAY';
      prepareBoard();
      startScreen.hidden = true;
      gameOverScreen.hidden = true;
      claim.hidden = true;
      saveStatusEl.textContent = '';
      running = true;
      schedule();
      canvas.focus({ preventScroll: true });
    }

    async function saveNamedScore() {
      const playerName = cleanName(nameInput.value);
      if (!playerName) {
        nameError.hidden = false;
        nameInput.focus({ preventScroll: true });
        return;
      }

      nameError.hidden = true;
      saveScoreButton.disabled = true;
      const saved = await submitScore(playerName);
      saveScoreButton.disabled = false;
      if (saved) {
        claim.hidden = true;
        enterButton.focus({ preventScroll: true });
      }
    }

    async function showStartScreen() {
      stop();
      if (sessionId && !scoreSubmitted && gameStartedAt) await submitScore('GUEST');
      prepareBoard();
      sessionId = '';
      gameStartedAt = 0;
      scoreSubmitted = false;
      gameOverScreen.hidden = true;
      claim.hidden = true;
      startScreen.hidden = false;
      saveStatusEl.textContent = '';
      startError.hidden = true;
      playButton.focus({ preventScroll: true });
    }

    async function exitGate() {
      stop();
      if (sessionId && !scoreSubmitted && gameStartedAt) await submitScore('GUEST');
      try { sessionStorage.setItem('yvx_snake_entered_v1', '1'); } catch (error) {}
      document.documentElement.style.overflow = oldOverflow;
      root.hidden = true;
      const main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    }

    root.addEventListener('keydown', event => {
      const keyMap = {
        ArrowUp: 'up', w: 'up', W: 'up',
        ArrowDown: 'down', s: 'down', S: 'down',
        ArrowLeft: 'left', a: 'left', A: 'left',
        ArrowRight: 'right', d: 'right', D: 'right'
      };
      const move = keyMap[event.key];
      if (move && running) {
        event.preventDefault();
        setDirection(move);
      }
    });

    nameInput.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        saveNamedScore();
      }
    });

    nameInput.addEventListener('input', () => {
      if (cleanName(nameInput.value)) nameError.hidden = true;
    });

    dirButtons.forEach(button => {
      button.addEventListener('click', () => {
        setDirection(button.dataset.dir);
        canvas.focus({ preventScroll: true });
      });
    });

    canvas.addEventListener('pointerdown', event => {
      touchStart = { x: event.clientX, y: event.clientY };
    });

    canvas.addEventListener('pointerup', event => {
      if (!touchStart || !running) return;
      const dx = event.clientX - touchStart.x;
      const dy = event.clientY - touchStart.y;
      touchStart = null;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 18) return;
      setDirection(Math.abs(dx) > Math.abs(dy) ? (dx > 0 ? 'right' : 'left') : (dy > 0 ? 'down' : 'up'));
    });

    playButton.addEventListener('click', startGame);
    skipButton.addEventListener('click', exitGate);
    saveScoreButton.addEventListener('click', saveNamedScore);
    playAgainButton.addEventListener('click', showStartScreen);
    enterButton.addEventListener('click', exitGate);

    renderScores([]);
    loadLeaderboard();
    prepareBoard();
    window.setTimeout(() => playButton.focus({ preventScroll: true }), 0);
  }

  function initAll() {
    document.querySelectorAll('[data-yvx-snake-entrance]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
